import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-employee-dropdown',
  templateUrl: './EmployeeDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => EmployeeDropdownComponent)}]
})
export class EmployeeDropdownComponent extends BaseDropdownComponent {

    selectItems: SelectItem[] = [];
    public employees: ent.Employee[] = [];

    constructor(private employeeService: serv.EmployeeService) 
    { 
        super();
    }

    ngOnInit(): void {
        //this.load();
    }

    public load(){

        var results = this.employeeService.getEmployeesFromCache();
        results.forEach(y=> this.selectItems.push({label:y.FullNameWithPersonnelNumber, value:y.ID}));
        results.forEach(y=> this.employees.push(y));
        this.loadDone.emit(null);
    }

}